<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 4L4.99999 9.99995" stroke="#18181B" stroke-linecap="round" />
    <path d="M16 4L27 10.013" stroke="#18181B" stroke-linecap="round" />
    <path d="M16 28L5 22.0264" stroke="#18181B" stroke-linecap="round" />
    <path d="M16 28L27 22.0131" stroke="#18181B" stroke-linecap="round" />
    <path d="M16 16V29" stroke="#18181B" stroke-linecap="round" />
    <path d="M16 5L16 29" stroke="#18181B" stroke-linecap="round" />
    <path d="M5 10L5 22" stroke="#18181B" stroke-linecap="round" />
    <path d="M27 10L27 22" stroke="#18181B" stroke-linecap="round" />
    <circle cx="16" cy="4" r="2.5" fill="white" stroke="#18181B" />
    <circle cx="27" cy="10" r="2.5" fill="white" stroke="#18181B" />
    <circle cx="27" cy="22" r="2.5" fill="white" stroke="#18181B" />
    <circle cx="5" cy="10" r="2.5" fill="white" stroke="#18181B" />
    <circle cx="5" cy="22" r="2.5" fill="white" stroke="#18181B" />
    <circle cx="16" cy="16" r="4.5" fill="#1DB6BD" stroke="#18181B" />
    <circle cx="16" cy="28" r="2.5" fill="white" stroke="#18181B" />
  </svg>
</template>

<script>
export default {
  name: 'Associations',
}
</script>

<style lang="scss" scoped></style>
